import script from "./ClassStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassStudents.vue?vue&type=script&setup=true&lang=js"

import "./ClassStudents.vue?vue&type=style&index=0&id=1402dcc4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1402dcc4"]])

export default __exports__